import { render } from "./SystemVmsTab.vue?vue&type=template&id=a9dd940e&scoped=true"
import script from "./SystemVmsTab.vue?vue&type=script&lang=js"
export * from "./SystemVmsTab.vue?vue&type=script&lang=js"

import "./SystemVmsTab.vue?vue&type=style&index=0&id=a9dd940e&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9dd940e"]])

export default __exports__